import { getEndpoint, PROFILE_SERVICE } from "../providers/endpoint.provider";
import { getRequestObjectByMethodType, handleApiError } from "../common/helpers/api";
import { useAuthStore } from "../store/auth/store";

export const sendProfileServiceRequest = async ({
    endpoint,
    data,
    propsToken,
    propsActiveClientId,
    requesType,
    queryString,
    customErrorMessage = null,
    suppressToast = false,
}) => {
    const authStore = useAuthStore.getState();
    const token = propsToken || authStore.token;
    const activeClientId = propsActiveClientId || authStore.activeClientId;
    const url = `${getEndpoint(PROFILE_SERVICE)}/${endpoint}`

    try {
        const response = await fetch(
            getRequestObjectByMethodType({
                url,
                token,
                data,
                activeClientId,
                queryString
            })[requesType]
        );

        handleApiError({ response, endpoint, customErrorMessage, suppressToast });

        return await response.json();
    } catch (error) {
        console.error(error);
        return { error };
    }
};
